const SCRIPT_ID = "login-turnstile-script"
let pending: { promise: Promise<void>; cancel: () => void } | null = null

// Share the download across login forms. Slow downloads remain live until an
// explicit retry; failed downloads are not cached as successes.
export function loadTurnstileScript(retry = false): Promise<void> {
  if (window.turnstile) return Promise.resolve()
  if (pending && !retry) return pending.promise
  pending?.cancel()
  document.getElementById(SCRIPT_ID)?.remove()
  const script = document.createElement("script")
  script.id = SCRIPT_ID
  script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
  script.async = true
  let cancel = () => {}
  const promise = new Promise<void>((resolve, reject) => {
    const finish = (error?: Error) => {
      script.onload = null
      script.onerror = null
      pending = null
      if (error) {
        script.remove()
        reject(error)
      } else resolve()
    }
    script.onload = () => finish(window.turnstile ? undefined : new Error("验证服务未就绪"))
    script.onerror = () => finish(new Error("验证服务加载失败"))
    cancel = () => finish(new Error("正在重试验证服务"))
  })
  pending = { promise, cancel }
  document.head.appendChild(script)
  return promise
}
